import { GetPaymentModel } from "@factory/model/query-model-payment";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { paymentFormDefault } from "./form.default";
import { PaymentFormSchema } from "./form.rule";

export const useFormDefaultPayment = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetPaymentModel | undefined) => {
    return !cachedValue
      ? paymentFormDefault
     : ({
        voucher: cachedValue.voucher,
        description: cachedValue.description,
        paymentType: cachedValue.payment_type,
        paymentDate: formatDate(cachedValue.payment_date) as any,
        amount: cachedValue.amount,
      } as PaymentFormSchema);
  };

  return {
    getDefault,
  };
};
